<template>
  <div class="sopItem">
    <div class="head-box">
      <h4 class="c-flex c-flex-item">
        标准作业程序(SOP)节点
      </h4>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="搜索节点名称"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click.native="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" class="c-m-l-10" @click="doNew()">
          新建SOP节点
        </el-button>
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'fpi-regex:name|string#or': searchValue,
                'in:state|array-integer#and': '0,1',
                beanName: 'SOPItem',
                title: '标准作业程序(SOP)节点'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table ref="table" :data="fpi.data" empty-text="暂无数据" height="calc(100% - 50px)">
          <c-table :fields="extFields">
            <template slot="code">
              <el-table-column prop="code" label="触发处编号" width="150px" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{
                    osg.codelabel(
                      'SOPItemCode' + (scope.row.type == 0 ? '' : scope.row.type),
                      scope.row.code
                    )
                  }}
                </template>
              </el-table-column>
            </template>
            <template slot="bizType">
              <el-table-column prop="bizType" label="业务类型" width="120px" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{
                    osg.codelabel(
                      'SOPBizType' + (scope.row.type == 0 ? '' : scope.row.type),
                      scope.row.bizType
                    )
                  }}
                </template>
              </el-table-column>
            </template>
          </c-table>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doRemove(scope.row._id)">
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="SOP节点"
      :visible.sync="openDetail"
      :close-on-click-modal="false"
      width="800px"
    >
      <c-form
        :formData="formData"
        :fields="extFields"
        :area="area"
        :upload="upload"
        :options="options"
        ref="form"
        labelWidth="160px"
        @changeForm="osg.changeForm"
      >
        <template slot="eventList">
          <el-form-item>
            <el-tag type="success" size="medium">支持拖拽事件调整执行顺序</el-tag>
          </el-form-item>
          <draggable v-model="formData.eventList">
            <transition-group>
              <el-form-item v-for="(event, index) in formData.eventList" :key="index">
                <div>事件{{ index + 1 }}</div>
                <div class="condition-card">
                  <el-card shadow="hover">
                    <el-form-item label="事件类型">
                      <el-select
                        v-model="formData.eventList[index].type"
                        placeholder="请选择"
                        @change="eventTypeChange(index)"
                      >
                        <el-option
                          v-for="item in options[
                            'SOPItemEventType' + (formData.type == 0 ? '' : formData.type)
                          ]"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item v-if="formData.eventList[index].type == 'form'" label="事件脚本">
                      <el-select
                        v-model="formData.eventList[index].groovyScriptId"
                        placeholder="支持搜索名称"
                        clearable
                        filterable
                      >
                        <template v-for="item in options.scripts">
                          <el-option
                            v-if="item.type == '14'"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="事件名称">
                      <el-input v-model="formData.eventList[index].name"></el-input>
                    </el-form-item>
                    <!-- 创建客户群chat -->
                    <template v-if="formData.eventList[index].type == 'chat'">
                      <!-- <el-form-item label="群名称">
                        <el-input v-model="formData.eventList[index].param.groupName"></el-input>
                      </el-form-item>
                      <el-form-item label="企微成员列表">
                        <el-select
                          v-model="formData.eventList[index].param.userIds"
                          placeholder="搜索姓名、手机号"
                          multiple
                          clearable
                          filterable
                          remote
                          :remote-method="getQwUsers"
                          :loading="querying"
                        >
                          <el-option
                            v-for="item in options.qwUsers"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="企微客户列表">
                        <el-select
                          v-model="formData.eventList[index].param.contactIds"
                          placeholder="搜索姓名、手机号、地址"
                          multiple
                          clearable
                          filterable
                          remote
                          :remote-method="getQwContacts"
                          :loading="querying"
                        >
                          <el-option
                            v-for="item in options.qwContacts"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item> -->
                    </template>
                    <!-- 拉成员进客户群addUser -->
                    <template v-else-if="formData.eventList[index].type == 'addUser'">
                      <el-form-item label="需要拉进群的企微成员列表">
                        <el-select
                          v-model="formData.eventList[index].param.addUserIds"
                          placeholder="搜索姓名、手机号"
                          multiple
                          clearable
                          filterable
                          remote
                          :remote-method="getQwUsers"
                          :loading="querying"
                        >
                          <el-option
                            v-for="item in options.qwUsers"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="是否需要拉登录人进群">
                        <el-select
                          v-model="formData.eventList[index].param.addCurrentUserId"
                          placeholder="请选择"
                          clearable
                        >
                          <el-option label="是" value="1"></el-option>
                          <el-option label="否" value="0"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="拉当前工单处理人进群">
                        <el-select
                          v-model="formData.eventList[index].param.addCurrentSAHandler"
                          clearable
                        >
                          <el-option
                            v-for="item in options.addCurrentSAHandler"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </template>
                    <!-- 发送文本消息text、发送短信sms -->
                    <template
                      v-else-if="
                        formData.eventList[index].type == 'text' ||
                          formData.eventList[index].type == 'sms'
                      "
                    >
                      <el-form-item label="消息内容">
                        <!-- <el-input
                          type="textarea"
                          autosize
                          v-model="formData.eventList[index].param.msgContext"
                        ></el-input> -->
                        <codemirror
                          :ref="'codemirror' + index"
                          v-model="formData.eventList[index].param.msgContext"
                          :options="editorOption"
                          class="codemirror-textarea"
                        ></codemirror>
                        <el-dropdown
                          placement="bottom"
                          style="width:auto !important;margin-top:10px;"
                        >
                          <el-button plain>
                            添加变量
                            <i class="el-icon-plus el-icon--right"></i>
                          </el-button>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item
                              v-for="(item, i) in options.SOPItemEventVariable"
                              :key="i"
                              @click.native="
                                insertValue({
                                  label: item.label,
                                  value: '${' + item.value + '}',
                                  index
                                })
                              "
                            >
                              {{ item.label }}
                            </el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </el-form-item>
                    </template>
                    <!-- 发送图片消息image、发送视频消息video、发送文件消息file-->
                    <template
                      v-else-if="
                        formData.eventList[index].type == 'image' ||
                          formData.eventList[index].type == 'video' ||
                          formData.eventList[index].type == 'file'
                      "
                    >
                      <el-form-item
                        :label="
                          formData.eventList[index].type == 'image'
                            ? '发送链接'
                            : formData.eventList[index].type == 'video'
                            ? '发送视频'
                            : formData.eventList[index].type == 'file'
                            ? '发送文件'
                            : '其他'
                        "
                      >
                        <el-radio-group
                          v-model="formData.eventList[index].param.current"
                          class="c-flex c-flex-item c-m-b-10"
                          style="height:32px;"
                        >
                          <el-radio label="0">上传文件</el-radio>
                          <el-radio label="1">自动获取</el-radio>
                        </el-radio-group>
                        <el-upload
                          v-if="formData.eventList[index].param.current != 1"
                          :action="upload.url"
                          :data="upload.data"
                          :file-list="formData.eventList[index].param.fileList"
                          :list-type="
                            formData.eventList[index].type == 'file' ? 'text' : 'picture-card'
                          "
                          :limit="5"
                          :on-exceed="osg.uploadExceed"
                          :before-upload="
                            file => {
                              return osg.beforeUpload(
                                file,
                                formData.eventList[index].type == 'file'
                                  ? 'pdf'
                                  : formData.eventList[index].type
                              );
                            }
                          "
                          :on-success="
                            (response, file, fileList) => {
                              formData.eventList[index].param.fileList = fileList;
                            }
                          "
                          :on-error="osg.uploadError"
                          :on-remove="
                            (file, fileList) => {
                              formData.eventList[index].param.fileList = fileList;
                              $forceUpdate();
                            }
                          "
                          :on-preview="osg.uploadPreview"
                          multiple
                          class="sop-item-upload"
                        >
                          <el-button
                            icon="el-icon-plus"
                            v-if="formData.eventList[index].type == 'file'"
                          >
                            点击上传
                          </el-button>
                          <i class="el-icon-plus" v-else></i>
                          <div
                            slot="file"
                            slot-scope="{ file, fileList }"
                            v-if="
                              osg.videoFormat.indexOf(
                                file.name &&
                                  file.name
                                    .split('.')
                                    [file.name.split('.').length - 1].toLowerCase()
                              ) != -1
                            "
                            style="width: 100%; height: 100%"
                          >
                            <span class="el-upload-list__item-actions" style="z-index: 100">
                              <span
                                class="el-upload-list__item-preview"
                                @click="osg.uploadPreview(file)"
                              >
                                <i class="el-icon-video-play"></i>
                              </span>
                              <span
                                class="el-upload-list__item-delete"
                                @click="onVideoRemove(file, index)"
                              >
                                <i class="el-icon-delete"></i>
                              </span>
                            </span>

                            <video
                              style="width: 100%; height: 100%; object-fit: fill; border-radius: 0"
                              :src="file.url"
                              class="avatar"
                              controls="controls"
                            >
                              您的浏览器不支持视频播放
                            </video>
                          </div>
                        </el-upload>
                      </el-form-item>
                    </template>
                    <!-- 发送H5消息h5、发送小程序消息mini-->
                    <template
                      v-else-if="
                        formData.eventList[index].type == 'h5' ||
                          formData.eventList[index].type == 'mini'
                      "
                    >
                      <el-form-item
                        label="H5页面链接"
                        v-if="formData.eventList[index].type == 'h5'"
                      >
                        <el-input v-model="formData.eventList[index].param.linkUrl">
                          <div
                            class="c-pointer"
                            slot="append"
                            @click="$set(formData.eventList[index].param, 'linkUrl', 'programAuto')"
                          >
                            自动获取
                          </div>
                        </el-input>
                      </el-form-item>
                      <el-form-item
                        label="小程序页面路径"
                        v-if="formData.eventList[index].type == 'mini'"
                      >
                        <el-input
                          v-model="formData.eventList[index].param.linkUrl"
                          placeholder="注意要以.html作为后缀"
                        >
                          <div
                            class="c-pointer"
                            slot="append"
                            @click="$set(formData.eventList[index].param, 'linkUrl', 'programAuto')"
                          >
                            自动获取
                          </div>
                        </el-input>
                      </el-form-item>
                      <!-- <el-form-item
                        label="小程序appid"
                        v-if="formData.eventList[index].type == 'mini'"
                      >
                        <el-input v-model="formData.eventList[index].param.appId"></el-input>
                      </el-form-item> -->
                      <el-form-item label="消息标题">
                        <el-input v-model="formData.eventList[index].param.title">
                          <div
                            class="c-pointer"
                            slot="append"
                            @click="$set(formData.eventList[index].param, 'title', 'programAuto')"
                          >
                            自动获取
                          </div>
                        </el-input>
                      </el-form-item>
                      <el-form-item label="消息摘要" v-if="formData.eventList[index].type == 'h5'">
                        <el-input v-model="formData.eventList[index].param.desc">
                          <div
                            class="c-pointer"
                            slot="append"
                            @click="$set(formData.eventList[index].param, 'desc', 'programAuto')"
                          >
                            自动获取
                          </div>
                        </el-input>
                      </el-form-item>
                      <el-form-item label="消息封面图片链接">
                        <el-input
                          v-model="formData.eventList[index].param.coverImgUrl"
                          placeholder="支持输入/自动获取/上传"
                          class="c-m-b-10"
                        >
                          <div
                            class="c-pointer"
                            slot="append"
                            @click="
                              $set(formData.eventList[index].param, 'coverImgUrl', 'programAuto')
                            "
                          >
                            自动获取
                          </div>
                        </el-input>
                        <el-upload
                          :action="upload.url"
                          :data="upload.data"
                          :file-list="formData.eventList[index].param.fileList"
                          list-type="picture-card"
                          :limit="1"
                          :on-exceed="osg.uploadExceed"
                          :before-upload="
                            file => {
                              return osg.beforeUpload(file, 'image');
                            }
                          "
                          :on-success="
                            (response, file, fileList) => {
                              formData.eventList[index].param.fileList = fileList;
                            }
                          "
                          :on-error="osg.uploadError"
                          :on-remove="
                            (file, fileList) => {
                              formData.eventList[index].param.fileList = fileList;
                              $forceUpdate();
                            }
                          "
                          :on-preview="osg.uploadPreview"
                          class="sop-item-upload"
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                      </el-form-item>
                    </template>
                    <!-- 发送自定义动作custom-->
                    <template v-else-if="formData.eventList[index].type == 'custom'">
                      <el-form-item label="自定义动作">
                        <el-select
                          v-model="formData.eventList[index].param.groovyScriptId"
                          placeholder="支持搜索名称"
                          clearable
                          filterable
                        >
                          <template v-for="item in options.scripts">
                            <el-option
                              v-if="item.type == '10'"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </template>
                        </el-select>
                      </el-form-item>
                    </template>
                    <!-- 项目任务 -->
                    <template v-if="formData.type == 2">
                      <el-form-item label="项目任务类型">
                        <el-select
                          v-model="formData.eventList[index].projectTaskType"
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in options.SOPProjectTaskType"
                            :key="item.value"
                            :label="item.label"
                            :value="Number(item.value)"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="延迟执行">
                        <el-input
                          v-model.number="formData.eventList[index].delayCount"
                          type="number"
                          placeholder="上一个任务之后推迟多少分钟执行"
                        >
                          <div slot="append">
                            分钟
                          </div>
                        </el-input>
                      </el-form-item>
                    </template>
                    <el-form-item label="消息字段">
                      <el-button icon="el-icon-chat-line-square" @click="openFormDesigner(index)">
                        配置（{{
                          formData.eventList[index].formParam
                            ? formData.eventList[index].formParam.length
                            : 0
                        }}）
                      </el-button>
                    </el-form-item>
                  </el-card>
                  <div class="card-remove">
                    <i class="el-icon-remove" @click="removeEvent(index)"></i>
                  </div>
                </div>
              </el-form-item>
            </transition-group>
          </draggable>
          <el-form-item v-if="formData.type || formData.type == 0">
            <el-dropdown placement="bottom" style="width:auto !important">
              <el-button type="primary" plain>
                添加事件
                <i class="el-icon-plus el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(item, i) in options[
                    'SOPItemEventType' + (formData.type == 0 ? '' : formData.type)
                  ]"
                  :key="i"
                  @click.native="addEvent(item.value)"
                >
                  {{ item.label }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
        </template>
      </c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 预览图片 -->
    <el-dialog :modal="false" custom-class="dialog-img" :visible.sync="upload.dialogVisible">
      <img width="100%" :src="upload.dialogImageUrl" alt />
    </el-dialog>
    <!-- 添加 FormDesigner 弹窗 -->
    <el-dialog
      title="配置消息字段"
      :visible.sync="formDesigner.show"
      width="90%"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      class="form-designer-dialog"
    >
      <form-designer ref="formDesigner" :fields="formDesigner.formParam" :isDialog="true" />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveFormDesignerFields">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import FormDesigner from '../biz/FormDesigner.vue';

export default {
  activated() {
    window.$this = this;
  },
  components: {
    codemirror,
    FormDesigner
  },
  name: 'SOPItem',
  data() {
    window.$this = this;
    return {
      name: 'SOPItem',
      fpi: { data: [] },
      searchValue: '',
      openDetail: false,
      extFields: [],
      formData: {
        eventList: [],
        exts: {}
      },
      rules: this.$util.rules,
      options: {
        codecfg_SOPItemEventType: { codeId: 'SOPItemEventType' },
        codecfg_SOPItemEventType1: { codeId: 'SOPItemEventType1' },
        codecfg_SOPItemEventType2: { codeId: 'SOPItemEventType2' },
        codecfg_SOPProjectTaskType: { codeId: 'SOPProjectTaskType' },
        qwUsers: [], // 企微成员
        qwContacts: [], // 企微客户
        scripts: [], // 功能插件
        codecfg_SOPItemEventVariable: { codeId: 'SOPItemEventVariable' },
        codecfg_addCurrentSAHandler: { codeId: 'addCurrentSAHandler' }
      },
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      querying: false,
      codemirror: {},
      editorOption: {
        tabSize: 4, // 缩进字符
        styleActiveLine: true, //
        lineNumbers: false, // 编辑器左侧显示行号
        line: true,
        lineWrapping: true, // 超出宽度后自动换行
        mode: 'text/x-groovy', // 语言
        theme: 'default', // 主题
        autoCloseBrackets: true, // 自动补全括号
        readOnly: false // 只读
      },
      formDesigner: {
        show: false,
        eventIndex: null,
        formParam: []
      }
    };
  },
  mounted() {
    this.osg.getFields('SOPItem', () => {
      this.osg.getFpi();
      this.getData();
    });
    this.getQwUsers();
    // this.getQwContacts();
    this.getScripts();
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    getData() {
      let params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'in:state|array-integer#and': '0,1',
        'regex:name|string#or': this.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('/basic/sopi/query.do', params, res => {
        res.data.map(item => {
          item.eventList.map(event => {
            if (event.type == 'addUser' && event.param) {
              if (event.param.addUserIds) {
                event.param.addUserIds = event.param.addUserIds.split(',');
              } else {
                event.param.addUserIds = [];
              }
            }
          });
        });
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doInit() {
      this.openDetail = false;
      this.formData = {
        eventList: [],
        exts: {}
      };
    },
    doSave() {
      if (this.osg.validate('formData', this)) {
        // 校验事件参数必填，处理不同事件类型的参数值数据格式
        let params = this.$util.deepCopy(this.formData);
        for (let i = 0; i < params.eventList.length; i++) {
          let eventIndex = `事件${i + 1}：`;
          let item = params.eventList[i];
          if (!item.name) {
            item.name = this.osg.codelabel(
              'SOPItemEventType' + (this.formData.type == 0 ? '' : this.formData.type),
              item.type
            );
          }
          if (item.type == 'addUser') {
            if (
              (!item.param.addUserIds || item.param.addUserIds.length == 0) &&
              item.param.addCurrentUserId == 0
            ) {
              this.osg.toast(eventIndex + '请选择需要拉进群的企微成员列表', 'warning');
              return;
            }
            if (!item.param.addCurrentUserId && item.param.addCurrentUserId != '0') {
              this.osg.toast(eventIndex + '请选择是否需要拉登录人进群', 'warning');
              return;
            }
            item.param.addUserIds = item.param.addUserIds.join(',');
          } else if (item.type == 'text' || item.type == 'sms') {
            if (!item.param.msgContext) {
              this.osg.toast(eventIndex + '请填写消息内容', 'warning');
              return;
            }
          } else if (item.type == 'image') {
            if (item.param.current == '1') {
              item.param.currentImages = '1';
              delete item.param.current;
            } else if (item.param.fileList && item.param.fileList.length > 0) {
              item.param.customImages = [];
              for (let j = 0; j < item.param.fileList.length; j++) {
                let file = item.param.fileList[j];
                if (file.response && file.response.key) {
                  item.param.fileList[j] = {
                    name: file.name,
                    url: this.osg.downloadUrl + file.response.key.replace(this.osg.downloadUrl, '')
                  };
                }
                item.param.customImages.push(item.param.fileList[j].url);
              }
            } else {
              this.osg.toast(eventIndex + '请至少上传1张图片', 'warning');
              return;
            }
          } else if (item.type == 'video') {
            if (item.param.current == '1') {
              item.param.currentVideos = '1';
              delete item.param.current;
            } else if (item.param.fileList && item.param.fileList.length > 0) {
              item.param.customVideos = [];
              for (let j = 0; j < item.param.fileList.length; j++) {
                let file = item.param.fileList[j];
                if (file.response && file.response.key) {
                  item.param.fileList[j] = {
                    name: file.name,
                    url: this.osg.downloadUrl + file.response.key.replace(this.osg.downloadUrl, '')
                  };
                }
                item.param.customVideos.push(item.param.fileList[j].url);
              }
            } else {
              this.osg.toast(eventIndex + '请至少上传1个视频', 'warning');
              return;
            }
          } else if (item.type == 'file') {
            if (item.param.current == '1') {
              item.param.currentFiles = '1';
              delete item.param.current;
            } else if (item.param.fileList && item.param.fileList.length > 0) {
              item.param.customFiles = [];
              for (let j = 0; j < item.param.fileList.length; j++) {
                let file = item.param.fileList[j];
                if (file.response && file.response.key) {
                  item.param.fileList[j] = {
                    name: file.name,
                    url: this.osg.downloadUrl + file.response.key.replace(this.osg.downloadUrl, '')
                  };
                }
                item.param.customFiles.push(item.param.fileList[j].url);
              }
            } else {
              this.osg.toast(eventIndex + '请至少上传1个文件', 'warning');
              return;
            }
          } else if (item.type == 'h5' || item.type == 'mini') {
            if (item.type == 'h5') {
              if (!item.param.linkUrl) {
                this.osg.toast(eventIndex + '请填写H5页面链接', 'warning');
                return;
              }
              if (!item.param.desc) {
                this.osg.toast(eventIndex + '请填写消息摘要', 'warning');
                return;
              }
            } else if (item.type == 'mini') {
              if (!item.param.linkUrl) {
                this.osg.toast(
                  eventIndex + '请填写小程序页面路径，注意要以.html作为后缀',
                  'warning'
                );
                return;
              }
              if (!item.param.linkUrl.endsWith('.html') && item.param.linkUrl != 'programAuto') {
                item.param.linkUrl += '.html';
              }
            }
            if (!item.param.title) {
              this.osg.toast(eventIndex + '请填写消息标题', 'warning');
              return;
            }
            if (!item.param.coverImgUrl) {
              // coverImgUrl值可能是链接或programAuto
              if (item.param.fileList && item.param.fileList.length > 0) {
                for (let j = 0; j < item.param.fileList.length; j++) {
                  let file = item.param.fileList[j];
                  if (file.response && file.response.key) {
                    item.param.fileList[j] = {
                      name: file.name,
                      url:
                        this.osg.downloadUrl + file.response.key.replace(this.osg.downloadUrl, '')
                    };
                  }
                  item.param.coverImgUrl = item.param.fileList[j].url;
                }
              } else {
                this.osg.toast(eventIndex + '请上传消息封面图片', 'warning');
                return;
              }
            }
          }
        }
        console.log('params', JSON.stringify(params));
        this.osg.ajax('/basic/sopi/upsert.do', { data: JSON.stringify(params) }, () => {
          this.osg.toast('保存成功');
          this.doInit();
          this.getData();
        });
      }
    },
    doEdit(row) {
      row = this.$util.deepCopy(row);
      // 查询已选择的需要添加的人员用于返显
      this.getAddedQwUsers(row);
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.openDetail = true;
      // 返显文本和短信中的标记{
      setTimeout(() => {
        for (let i = 0; i < row.eventList.length; i++) {
          if (row.eventList[i].type == 'text' || row.eventList[i].type == 'sms') {
            this.formatVariable(i);
          }
        }
      }, 200);
    },
    doEnable(id) {
      this.osg.ajax('basic/sopi/enable.do', { id }, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('basic/sopi/disable.do', { id }, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax('basic/sopi/remove.do', { id }, () => {
          this.getData();
          this.osg.toast('删除成功！');
        });
      });
    },
    addEvent(type) {
      let obj = { type, param: {} };
      if (type == 'image' || type == 'video' || type == 'file') {
        obj.param.current = '0';
      }
      if (type == 'addUser') {
        obj.param.addUserIds = [];
      }
      this.formData.eventList.push(obj);
    },
    removeEvent(index) {
      this.formData.eventList.splice(index, 1);
    },
    eventTypeChange(index) {
      let obj = {
        type: this.formData.eventList[index].type,
        param: {}
      };
      if (obj.type == 'image' || obj.type == 'video' || obj.type == 'file') {
        obj.param.current = '0';
      }
      this.$set(this.formData.eventList, index, obj);
      this.$set(this.formData.eventList[index], 'groovyScriptId', '');
    },
    getQwUsers(query) {
      this.querying = true;
      this.osg.ajax(
        'user/query.do',
        {
          page: 1,
          rows: 20,
          'is:state|integer#and': 1,
          'exists:qwUserId|boolean#and': true,
          // 'in:_id|array#or': selectedIds.join(),
          'regex:name|string#or': query,
          'regex:phone|string#or': query
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.qwUsers = res.data;
          if (!query) {
            this.getAddedQwUsers(this.formData);
          }
          this.querying = false;
        },
        { noload: true }
      );
    },
    getAddedQwUsers(row) {
      // 汇总当前节点已添加的全部userId
      let addUserIds = [];
      row.eventList.map(item => {
        if (item.type == 'addUser' && item.param.addUserIds) {
          addUserIds = addUserIds.concat(item.param.addUserIds);
        }
      });
      addUserIds = Array.from(new Set(addUserIds));
      // 找出options中不存在的userId发请求查询
      let ids = [];
      addUserIds.map(userId => {
        if (!this.options.qwUsers.some(option => option.value == userId)) {
          ids.push(userId);
        }
      });
      this.osg.ajax(
        'user/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          'exists:qwUserId|boolean#and': true,
          'in:_id|array#or': ids.join()
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.qwUsers = this.options.qwUsers.concat(res.data);
        },
        { noload: true }
      );
    },
    getQwContacts(query) {
      this.querying = true;
      this.osg.ajax(
        'basic/contacts/query.do',
        {
          page: 1,
          rows: 20,
          'is:state|integer#and': 1,
          'exists:exts.qwExternalUserId|boolean#and': true,
          'regex:name|string#or': query,
          'regex:phone|string#or': query,
          'regex:address|string#or': query
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.qwContacts = res.data;
          this.querying = false;
        },
        { noload: true }
      );
    },
    getScripts() {
      this.osg.ajax(
        'groovyScript/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          'in:type|array-integer#and': '10,14'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.scripts = res.data;
        },
        { noload: true }
      );
    },
    onVideoRemove(file, index) {
      let fileIndex = this.formData.eventList[index].param.fileList.find(
        item => item.url == file.url
      );
      this.formData.eventList[index].param.fileList.splice(fileIndex, 1);
    },
    // 插入变量
    insertValue({ label, value, index }) {
      this.codemirror = this.$refs['codemirror' + index][0].codemirror;
      //获取codemirror光标位置
      const pos1 = this.codemirror.getCursor();
      const pos2 = {};
      pos2.line = pos1.line;
      pos2.ch = pos1.ch;

      //制作标签dom(颜色样式自行设置)
      var dom = document.createElement('span');
      dom.className = 'cm-field';
      dom.innerHTML = label;

      const bookMark = value;
      const endPos = { line: pos2.line, ch: pos2.ch + bookMark.length };

      this.codemirror.replaceRange(bookMark, pos2); //先插入字符串再对插入字符串进行标签制定（其实就是在codemirror中动态添加标签）
      this.codemirror.markText(pos2, endPos, {
        replacedWith: dom
      });
      this.codemirror.focus();
    },
    // 逐行返显变量
    formatVariable(index) {
      this.codemirror = this.$refs['codemirror' + index][0].codemirror;
      let lineCount = this.codemirror.lineCount();
      for (let line = 0; line < lineCount; line++) {
        let lineValue = this.codemirror.getLine(line);
        let regex = /\${.*?}/g;
        let varStrArr = lineValue.match(regex);
        if (!varStrArr) continue;
        let index = 0;
        varStrArr.map(varStr => {
          let ch = lineValue.indexOf(varStr, index); // 查找到变量$下标
          index = ch + varStr.length; // 下次开始查找的位置
          // 获取变量中文名
          let newStr = varStr.substring(2, varStr.length - 1);
          let innerHTML = this.osg.codelabel('SOPItemEventVariable', newStr);
          // 将变量返显为标签
          var dom = document.createElement('span');
          dom.className = 'cm-field';
          dom.innerHTML = innerHTML;
          this.codemirror.markText(
            { line, ch },
            { line, ch: index },
            {
              replacedWith: dom
            }
          );
        });
      }
      // this.editor.visible = true;
    },
    // 点击消息字段时打开 FormDesigner
    openFormDesigner(index) {
      this.formDesigner.eventIndex = index;
      this.formDesigner.formParam = this.formData.eventList[index].formParam || [];
      this.formDesigner.show = true;
    },
    // 保存 FormDesigner 配置的字段
    saveFormDesignerFields() {
      if (this.formDesigner.eventIndex !== null) {
        // 获取 FormDesigner 组件中配置的字段
        const formParam = this.$refs.formDesigner.fields;
        // 保存到当前事件的 field 字段
        this.$set(this.formData.eventList[this.formDesigner.eventIndex], 'formParam', formParam);
      }
      this.formDesigner.show = false;
      window.$this = this;
    }
  }
};
</script>
<style lang="scss">
.sopItem {
  .sop-item-upload {
    .el-upload-list__item {
      width: 60px;
      height: 60px;
    }
    .el-upload--picture-card {
      width: 60px;
      height: 60px;
      line-height: 70px;
    }
  }
  .codemirror-textarea.vue-codemirror {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    overflow: hidden;
    font-size: 13px;
    color: #606266;
    min-height: 32px;
    line-height: 22px;
    box-sizing: border-box;
    .CodeMirror {
      width: calc(100% - 10px) !important;
      height: auto;
      min-height: 30px;
      padding-left: 10px;
      color: #606266;
      .CodeMirror-scroll {
        .CodeMirror-sizer {
          min-height: 32px !important;
          min-width: 200px !important;
          // border-right: 0;
        }
      }
      .CodeMirror-gutters {
        display: none;
      }
    }
    .cm-field {
      background-image: linear-gradient(-117deg, #90dcd4, #7cdfc2);
    }
    .cm-current-field,
    .cm-field {
      display: inline-block;
      height: 22px;
      line-height: 22px;
      color: #fff;
      margin: 0 3px;
      border-radius: 3px;
      padding: 0 8px;
      font-size: 13px;
    }
    .cm-delField {
      display: inline-block;
      height: 22px;
      line-height: 22px;
      background: #f26245;
      color: #fff;
      margin: 0 3px;
      border-radius: 3px;
      padding: 0 8px;
      font-size: 13px;
    }
    .CodeMirror-widget {
      height: 28px;
      line-height: 28px;
    }
  }
}
#app {
  .form-designer-dialog {
    .el-dialog {
      width: calc(100vw - 100px) !important;
      height: calc(100vh - 100px) !important;
      max-height: calc(100vh - 100px) !important;
      margin: 50px !important;
      .el-dialog__body {
        padding: 0;
        .fd {
          height: 100%;
        }
      }
    }
  }
}
</style>
